var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6494 18.5435C19.8608 18.7548 19.9795 19.0414 19.9795 19.3403C19.9795 19.6392 19.8608 19.9259 19.6494 20.1372C19.4381 20.3486 19.1514 20.4673 18.8525 20.4673C18.5537 20.4673 18.267 20.3486 18.0557 20.1372L12.1035 14.1831L6.14941 20.1353C5.93807 20.3467 5.65142 20.4654 5.35254 20.4654C5.05365 20.4654 4.76701 20.3467 4.55566 20.1353C4.34432 19.924 4.22559 19.6373 4.22559 19.3385C4.22559 19.0396 4.34432 18.7529 4.55566 18.5416L10.5097 12.5894L4.55754 6.63533C4.34619 6.42399 4.22746 6.13735 4.22746 5.83846C4.22746 5.53957 4.34619 5.25293 4.55754 5.04159C4.76888 4.83024 5.05553 4.71151 5.35441 4.71151C5.6533 4.71151 5.93994 4.83024 6.15129 5.04159L12.1035 10.9956L18.0575 5.04065C18.2689 4.8293 18.5555 4.71057 18.8544 4.71057C19.1533 4.71057 19.4399 4.8293 19.6513 5.04065C19.8626 5.25199 19.9814 5.53864 19.9814 5.83752C19.9814 6.13641 19.8626 6.42305 19.6513 6.6344L13.6972 12.5894L19.6494 18.5435Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.27ac2eab393761ad2b6dba6cdf84ba0a.svg";
export { ForwardRef as ReactComponent };